import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import StatsCategories from './components/StatsCategories';
import Comparison from './components/Comparison';
import Safety from './components/Safety';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import SEOArticles from './components/SEOArticles';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://acbuyspreadsheet.one';

const homeSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "AcBuy Spreadsheet",
  "url": siteUrl,
  "description": "Best AcBuy Spreadsheet 2026: Trusted Products, Sellers & Buying Guides. Discover verified product links and expert shopping guides.",
  "image": "https://readdy.ai/api/search-image?query=Stylized%20abstract%20minimalist%20product%20display%20background%20with%20soft%20warm%20terracotta%20and%20cream%20gradient%2C%20geometric%20shapes%2C%20circular%20accents%2C%20modern%20editorial%20style%2C%20light%20airy%20atmosphere%2C%20professional%20photography%20backdrop%2C%20no%20text%2C%20subtle%20texture%2C%20elegant%20artistic%20design&width=1800&height=1000&seq=hero-main-v4&orientation=landscape",
  "potentialAction": {
    "@type": "SearchAction",
    "target": siteUrl + "/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "AcBuy Spreadsheet",
  "url": siteUrl,
  "logo": "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/acdcfd47829ab306d380ea84eb14e50b.jpeg",
  "description": "AcBuy Spreadsheet provides a verified, community-maintained database of trusted products and sellers across 14 categories, updated daily.",
  "sameAs": [
    "https://kaspreadsheet.com"
  ]
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <StatsCategories />
        <Comparison />
        <SEOArticles />
        <Safety />
        <FAQ />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}